import { datadogLogs } from '@datadog/browser-logs';
import { datadogBrowserLogsBeforeSend } from '@omers-packages/common-pii-mask';
import { env } from '@omers-packages/next-isomorphic-runtime-env';

if (typeof window !== 'undefined') {
  datadogLogs.init({
    clientToken: env('NEXT_PUBLIC_DATADOG_CLIENT_TOKEN') as string,
    site: 'datadoghq.eu',
    service: 'eaccess-front-end',
    env: env('NEXT_PUBLIC_APP_ENV'),
    version: env('NEXT_PUBLIC_GIT_TAG') || `v-${env('NEXT_PUBLIC_GIT_SHA')}`,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: datadogBrowserLogsBeforeSend()
  });
}
